<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
export default {
  name: "ForgotPassword",
  data() {
    return {
      loadVisible: false,
      pinError: null,
      pin: null,
      message: null,
    };
  },
  methods: {
    onLogin() {
      if (!this.pin) {
        this.pinError = "Zəhmət olmasa FİN daxil edin";
        return;
      } else if (this.pin.length != 7) {
        this.pinError = "FİN 7 simvoldan ibarət olmalıdır";
        return;
      }
      this.pinError = null;
      this.loadVisible = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "auth/forgot",
        method: "POST",
        data: { pin: this.pin },
      })
        .then((response) => {
          this.loadVisible = false;
          if (!response.data.error) this.message = response.data.data;
          else {
            this.$message.error(response.data.error.message);
            this.message = null;
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          this.loadVisible = false;
          this.message = null;
       
        });
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
